<!--Only displayed when control is available-->
<ng-container *ngIf="ableToDisplayValidationMessages(ngControl)">
  <ng-template
    [ngTemplateOutlet]="alternativeTemplate || defaultTemplate"
    [ngTemplateOutletContext]="templateContext"
  >
  </ng-template>
</ng-container>

<!--Default validation summary template-->
<ng-template
  #defaultTemplate
  let-ngControl="ngControl"
  let-controlLabel="controlLabel"
  let-validationMessages="validationMessages"
>
    <ul class="validation-summary" *ngIf="validationMessages && validationMessages.length > 0">
      <li *ngFor="let validationMessage of validationMessages;">
        {{validationMessage.content}}
      </li>
    </ul>
</ng-template>
